/**
 * Composant pour afficher les documents publics
 * Affiche directement dans un iframe - le backend gère le Content-Type
 */
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const DocumentViewer = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  // URL directe vers le document - nginx route vers Django
  const documentUrl = `/documents/${slug}/`;

  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Barre de navigation */}
      <div className="bg-white shadow-sm border-b px-4 py-3 flex items-center justify-between flex-shrink-0">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-600 hover:text-gray-900 flex items-center gap-2 text-sm"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Retour
        </button>

        <a
          href={documentUrl}
          download
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Télécharger
        </a>
      </div>

      {/* Iframe plein écran pour afficher le document */}
      <iframe
        src={documentUrl}
        className="flex-1 w-full border-0"
        title="Document"
      />
    </div>
  );
};

export default DocumentViewer;
